<div class="form-input-text">
    <mat-form-field [color]="color" [appearance]="outlined" [ngStyle]="{'maxWidth': maxWidth}">
        <mat-label>{{text}}</mat-label>
        <textarea matInput [type]="type" [name]="name" [formControlName]="formControlName" placeholder="" [disabled]="disabled"></textarea>
        <mat-hint *ngIf="hintText">{{hintText}}</mat-hint>
        <mat-error *ngIf="errorMsg">{{errorMsg}}</mat-error>
    </mat-form-field>
</div>
